import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { reviews } from "../data/reviews";

// Pick the 6 most-impactful customer stories to rotate on the homepage.
const PICKS = [2, 8, 13, 15, 18, 19].map((i) => reviews[i]).filter(Boolean);
const ROTATE_MS = 6000;

export default function CustomerStories() {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((x) => (x + 1) % PICKS.length), ROTATE_MS);
    return () => clearInterval(t);
  }, [paused]);

  if (PICKS.length === 0) return null;
  const r = PICKS[i];

  return (
    <section
      className="bg-[#F5F8FC] border-y border-[#D9E1EA]"
      data-testid="home-customer-stories"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="ssc-container py-12 md:py-16">
        <div className="flex items-end justify-between flex-wrap gap-2 mb-6">
          <div>
            <div className="text-[10px] font-extrabold tracking-[0.2em] uppercase text-[var(--ssc-blue)]">Customer Stories</div>
            <h2 className="text-2xl md:text-3xl font-black text-[#081426] tracking-tight">What people say about working with Scott</h2>
          </div>
          <Link to="/reviews" className="text-sm font-bold text-[var(--ssc-blue)] hover:underline" data-testid="stories-all-cta">
            Read all reviews →
          </Link>
        </div>

        <div className="bg-white border border-[#D9E1EA] rounded-2xl p-6 md:p-10 relative" data-testid="stories-card">
          <Quote className="text-[var(--ssc-blue)]/30 absolute top-4 left-5" size={36} />
          <blockquote className="text-lg md:text-xl text-[#081426] font-medium leading-relaxed pl-10 md:pl-12" data-testid={`stories-text-${i}`}>
            "{r.text}"
          </blockquote>
          <div className="mt-5 flex items-center justify-between flex-wrap gap-3 pl-10 md:pl-12">
            <div className="text-sm font-extrabold text-[var(--ssc-navy)] uppercase tracking-widest">{r.name}</div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setI((x) => (x - 1 + PICKS.length) % PICKS.length)}
                className="w-9 h-9 rounded-full bg-[#F5F8FC] border border-[#D9E1EA] text-[var(--ssc-navy)] flex items-center justify-center hover:bg-[var(--ssc-blue)] hover:text-white transition-colors"
                aria-label="Previous story"
                data-testid="stories-prev"
              ><ChevronLeft size={18} /></button>
              <div className="flex gap-1.5" data-testid="stories-dots">
                {PICKS.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setI(idx)}
                    aria-label={`Go to story ${idx + 1}`}
                    className={`w-2 h-2 rounded-full transition-all ${idx === i ? "bg-[var(--ssc-blue)] w-6" : "bg-[#D9E1EA]"}`}
                  />
                ))}
              </div>
              <button
                onClick={() => setI((x) => (x + 1) % PICKS.length)}
                className="w-9 h-9 rounded-full bg-[#F5F8FC] border border-[#D9E1EA] text-[var(--ssc-navy)] flex items-center justify-center hover:bg-[var(--ssc-blue)] hover:text-white transition-colors"
                aria-label="Next story"
                data-testid="stories-next"
              ><ChevronRight size={18} /></button>
            </div>
          </div>
        </div>

        <p className="text-xs text-[var(--ssc-ink-2)] mt-4">
          Over 15 years of helping customers shop with confidence. <Link to="/about-scott" className="text-[var(--ssc-blue)] font-bold hover:underline">Meet Scott →</Link>
        </p>
      </div>
    </section>
  );
}
